import React from "react";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";

import right_arrow from "../../resources_catalog/icons/ico_right_arrow.svg";
import { useRtoaster } from "../../hooks/useRtoaster";

export const Catalog404Container = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  // rtoasterタグ生成
  useRtoaster();
  const onClickBack = () => {
    history.push(props.path);
  }
  return (
    <div className="catalog404Wrap">
      <div className="catalog404">
        <div className="catlogBackBlock"></div>
        <div className="catalogContentsBlock">
          <div className="catalogContentsTitle">
            <p>ページがみつかりませんでした</p>
            <p className="catalogContentsTitleCaption">404 Not Found</p>
          </div>
          <div className="catalogContents404Text">
            <p>申し訳ございません。</p>
            <p>お探しのページは一時的にアクセスできない状況にあるか、</p>
            <p>移動もしくは削除された可能性があります。</p>
          </div>
          <div className="catalogContentsButton">
            <p>HOMEに戻る</p>
            <img src={right_arrow} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
